module.exports = __webpack_public_path__ + "img/Logotipo-Televet-Play-Color.b86a12d7.png";